export default __webpack_public_path__ + "static/Konditor Seite 1-70a998bf91d31ff6ead166731bfd0bf7.jpg";